export default {
  common: {
    addToCart: 'Lisää ostoskoriin',
    removeFromCart: 'Poista ostoskorista',
    next: 'Seuraava',
    details: 'Yksityiskohdat',
    firstName: 'Etunimi',
    lastName: 'Sukunimi',
    email: 'Sähköposti',
    phoneNumber: 'Puhelinnumero',
    sender: 'Lähettäjä',
    recipient: 'Vastaanottaja',
    address: 'Osoite',
    pickupAddressTitle: 'Nouto-osoite',
    collectionDateTitle: 'Keräyspäivä',
    billingInformationTitle: 'Laskutustiedot',
    additionalInfo: 'Lisätiedot',
    arrivesAt: 'Saapuu',
    postalCode: 'Postinumero',
    streetAddress: 'Katuosoite',
    city: 'Kaupunki',
    save: 'Tallenna',
  },
  cartPages: {
    shoppingCart: 'Ostoskori',
    selectUserType: 'Valitse käyttäjätyyppi',
    orderDetails: 'Tilauksen tiedot',
    orderDetailsBilling: 'Tilauksen tiedot',
    proceedToCheckout: 'Siirry kassalle',
    emptyCart: 'Ostoskorisi on tyhjä',
    errorCart: 'Virhe ladattaessa ostoskoria',
    shippingFee: 'Toimitusmaksu',
    totalAmount: 'Kokonaismäärä (sisältää ALV)',
    senderDetails: 'Lähettäjän tiedot',
    receiverDetails: 'Vastaanottajan tiedot',
  },
  validation: {
    firstNameRequired: 'Etunimi on pakollinen',
    lastNameRequired: 'Sukunimi on pakollinen',
    invalidEmail: 'Virheellinen sähköposti',
    emailRequired: 'Sähköposti on pakollinen',
    phoneNumberRequired: 'Puhelinnumero on pakollinen',
    userTypeRequired: 'Käyttäjätyyppi on pakollinen',
    invalidUserType: 'Virheellinen käyttäjätyyppi',
  },
  products: {
    searchPlaceholder: 'Hae tuotteita',
    filterProducts: 'Suodata tuotteet',
    loadMore: 'Lataa lisää',
    noProductsFound: 'Inga produkter hittades.',
    tryDifferentFilters: 'Prova olika filter eller söktermer.',
    errorLoadingProducts: 'Virhe ladattaessa tuotteita',
  },
  footer: {
    aboutUs: 'Tietoa meistä',
    tos: 'Käyttöehdot',
    privacyPolicy: 'Tietosuojakäytäntö',
  },
  delivery: {
    leaveAtDoor: 'Jätä ovelle',
    trackDelivery: 'Seuraa toimitustasi',
    messageDriver: 'Viesti kuljettajalle',
    deliveryInfo: 'Toimitustiedot',
    additionalServices: 'Lisäpalvelut',
  },
  homeHeader: {
    title: 'Kodin kierrätyspalvelut',
    text1: 'Maksat vain 4,90 € kuljetusmaksun ja tuotekohtaisen maksun.',
    text2: 'Tilaa kierrätystä, pesua tai huoltoa vaativien tuotteiden nouto kotioveltasi !',
    text3: 'Nauti elämästä hyvällä omallatunnolla!',
    linkText: 'Miten se toimii?',
    deliveryText: 'Toimitukset',
    recycledItemsText: 'kierrätetyt esineet',
    savedCO2Text: 'Säästetty CO2 g',
    subtitlePart1: 'Lähetä',
    subtitlePart2: ' helposti kotiovelta!',
  },
  homeFooter: {
    title: 'Miten se toimii?',
    text1:
      'MyFetch kaupasta voit tilata noudot nopeasti ja helposti kotiovelle kodin erilaisille palveluille. Kaupassa on tarjolla palveluita mm.  kierrätykseen, pyykkien kuljetukseen pesulaan ja vanhojen laitteiden uusiokäyttöön. Palvelut lisääntyvät koko ajan ja mukana on tällä hetkellä kiertotalouteen liittyviä toimijoita kuten esimerkiksi UFF ja Inrego.',
    text2:
      'Voit yhdistää yhdelle noudolle niin pyykit kuin vanhojen IT-laitteiden kierrätyksen ja lähettää samalla vielä pahvit ja pullot kierrätykseen, kätevää eikö totta!',
    text3:
      'Kun tilaat noudon Ma – Pe klo 14 mennessä, tullaan nouto suorittamaan vielä samana iltana, kalenterista voit myös valita itsellesi sopivan noutopäivän. Kaikki noudot tapahtuvat klo 17 – 22 välillä ja ilmoitamme tarkemman noutoajan tunnin tarkkuudella etukäteen noutopäivänä.',
    text4:
      'Eri palveluiden hinnat, esimerkiksi pyykkien pesupalvelut tai fillarien huollot, veloitetaan asiakkaalta palveluntarjoajan toimesta erikseen, kts. tuotteen lisätiedot. Enexus luovuttaa laskutukseen ja paluukuljetukseen tarvittavat henkilötiedot palveluntarjoajalle tilauksen yhteydessä.',
  },
  userTypePicker: {
    startTransporting: 'Aloitetaan kuljetus',
    selectZip: 'Aloita valitsemalla postinumero',
    sender: 'Olen lähettäjä',
    receiver: 'Olen vastaanottaja',
    receiverInfo:
      'Jos olet vastaanottaja, varmista, että lähettäjä on paikalla noutoajankohtana. Emme toista noutoa, jos lähettäjä puuttuu tai on hallitsemattomia ongelmia.',
    collectionZipPlaceholder: 'Syötä noutopaikan postinumero',
    deliveryZipPlaceholder: 'Syötä toimituspaikan postinumero',
  },
}
